<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<mat-card *ngIf="!isLoading">
  <form [formGroup]="passwordChangeForm" (ngSubmit)="onFormSubmit()">
    <h3>{{ 'PASSWORD.CHANGE_TITLE' | translate }}</h3>
    <mat-form-field appearance="outline">
      <input
        matInput
        [placeholder]="'PASSWORD.CURRENT_PLACEHOLDER' | translate"
        formControlName="password"
        [type]="passwordHide ? 'password' : 'text'"
      />
      <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{
        passwordHide ? "visibility_off" : "visibility"
      }}</mat-icon>
      <mat-error *ngIf="password.hasError('required') && submitted">
        {{ 'PASSWORD.CURRENT_REQUIRED' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <input
        matInput
        [placeholder]="'PASSWORD.NEW_PLACEHOLDER' | translate"
        formControlName="newPassword"
        [type]="newPasswordHide ? 'password' : 'text'"
      />
      <mat-icon matSuffix (click)="newPasswordHide = !newPasswordHide">{{
        newPasswordHide ? "visibility_off" : "visibility"
      }}</mat-icon>
      <mat-error *ngIf="newPassword.hasError('required') && submitted">
        {{ 'PASSWORD.NEW_REQUIRED' | translate }}
      </mat-error>
    </mat-form-field>
    <div>
      <button mat-raised-button primaryButton sm-full-width type="submit">
        {{ 'PASSWORD.SAVE' | translate }}
      </button>
    </div>
    <br />
    <h3>{{ 'PASSWORD.CANT_REMEMBER' | translate }}</h3>
    <button
      mat-stroked-button
      secondaryButton
      sm-full-width
      (click)="sendPasswordChangeEmail()"
    >
      {{ 'PASSWORD.SEND_RESET_EMAIL' | translate }}
    </button>
  </form>
</mat-card>
